<template>
  <div class="tree" v-cloak>
    <div class="l_tree_container">
      <ew-tree :model="testdata"></ew-tree>
    </div>
  </div>
</template>

<style></style>

<script>
import ewTree from "@/components/ewTree.vue";
export default {
  name: "tree",
  props: {
    fd: Object
  },
  components: {
    ewTree
  },
  data() {
    return {
      // 给他定义一个字段，type = 1，说明是目录1
      // 给他们都定义一个id
      testdata: []
    };
  },
  mounted() {
    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/productListCatalog/getCatalogData.form")
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.testdata = res.data.dataList;
        }
      });
  }
};
</script>

<style></style>
